import { useTranslation } from "react-i18next";

import { LicenseInspection } from "@admin/api/license";
import { Box, Typography } from "@mui/material";

import { useStyles } from "./AdminLicensesPage.style";

type Props = {
    inspection: LicenseInspection;
};

export const InspectionResult = ({ inspection }: Props) => {
    const { t } = useTranslation(["pages"]);
    const { classes } = useStyles();

    const entries: { key: keyof LicenseInspection; label: string }[] = [
        { key: "serverData", label: t("pages:adminLicensesPage.inspect.field.serverData") },
        { key: "serverNonce", label: t("pages:adminLicensesPage.inspect.field.serverNonce") },
        { key: "deviceData", label: t("pages:adminLicensesPage.inspect.field.deviceData") },
        { key: "deviceNonce", label: t("pages:adminLicensesPage.inspect.field.deviceNonce") },
    ];

    return (
        <Box className={classes.inspectionBox}>
            {entries.map((entry) => (
                <Box key={entry.key}>
                    <Typography variant="subtitle2" fontWeight="bold">
                        {entry.label}
                    </Typography>
                    <Typography variant="body2" className={classes.inspectionValue}>
                        {inspection[entry.key]}
                    </Typography>
                </Box>
            ))}
        </Box>
    );
};
